<template>
    <Teleport to="body">
        <div
            ref="modal"
            class="modal"
            tabindex="-1"
            :aria-label="title"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ title }}</h5>
                        <button
                            type="button"
                            class="btn-close"
                            aria-label="Close"
                            @click="close"
                        ></button>
                    </div>
                    <div class="modal-body description-modal-body" v-html="safeHtml"></div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="close">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
    import { Modal } from 'bootstrap'
    import { descriptionHtml } from '@/helpers/string'

    export default {
        name: 'QuoteDescriptionModal',
        props: {
            title: { type: String, default: 'Quote description' },
        },
        data() {
            return { description: '' }
        },
        computed: {
            safeHtml() {
                return descriptionHtml(this.description)
            },
        },
        mounted() {
            this.modalInstance = new Modal(this.$refs.modal)
            this.$refs.modal.addEventListener('hidden.bs.modal', this.restoreFocus)
        },
        beforeUnmount() {
            // No fade transition: cleanup is synchronous even when switching tabs.
            this.modalInstance.hide()
            this.$refs.modal.removeEventListener('hidden.bs.modal', this.restoreFocus)
            this.modalInstance.dispose()
        },
        methods: {
            async open(description) {
                this.trigger = document.activeElement
                this.description = description
                await this.$nextTick()
                this.modalInstance.show()
            },
            close() {
                this.modalInstance.hide()
            },
            restoreFocus() {
                if (this.trigger?.isConnected) this.trigger.focus()
            },
        },
    }
</script>

<style scoped>
    html:not([data-theme='dark']) .modal-title,
    html:not([data-theme='dark']) .description-modal-body,
    html:not([data-theme='dark']) .description-modal-body :deep(*) {
        color: #000;
    }

    .description-modal-body {
        overflow-wrap: anywhere;
        text-align: left;
    }

    .description-modal-body :deep(table) {
        width: 100%;
        table-layout: fixed;
    }

    .description-modal-body :deep(td),
    .description-modal-body :deep(th) {
        padding: 0.5rem;
        vertical-align: top;
        text-align: left;
        border: 1px solid var(--color-border, #ddd);
    }
</style>
